cv.AppealEditorView = Marionette.LayoutView.extend({
  className : 'view-appeal-editor',

  template: cv.Templates['appeal_editor/view'],

  bindings : {
    ':el' : {
      observe : function(){
        var observe_data = [];
        observe_data.push('draft');
        observe_data.push(this.options.id);
        return observe_data;
      },
      update: function($el, value, model, options) {
        if(model.get('draft') != model.get(this.options.id)){
          if(this.$('.last-modified').html() == ''){
            this.$('.last-modified').html('You have unsaved changes.');
          }
        }else{
          this.$('.last-modified').html('');
        }
      }
    },
  },

  events: {
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);
    this.ck_editor = null;
    this.save_draft = _.debounce(this.saveDraft, 1500);

    console.log('AppealEditorView initialized');
  },

  templateHelpers: function () {
    return {
    };
  },

  setDraftURL: function(url){
    this.options.draft_url = url;
    this.options.enable_draft = true;
  },

  saveDraft: function(){
    // If we don't have a draft URL then we save the model and change the draft url
    if(this.options.draft_url == ''){
      this.model.save({
        draft : this.ck_editor.getData()
      },{
        success: _.bind(function(){
          this.options.draft_url = this.model.url();
        }, this)
      })
    }else{
      $.ajax({
        url: this.options.draft_url,
        data : {
          draft : this.ck_editor.getData()
        },
        dataType: "json",
        type: "PUT",
        success: _.bind(function(data){
        }, this),
        error: _.bind(function(data){
        }, this)
      });
    }
  },

  onAttach: function(){
    // Attach the editor
    this.attachEditor();
  },

  attachEditor: function(){
    CKEDITOR.ClassicEditor
    .create(this.$('#ck-editor').get(0),{
      s3Upload: {
        policyUrl : "/s3_policy"
      }
    })
    .then(_.bind(function(editor){
      this.ck_editor = editor;

      // Set initial data
      if(this.options.enable_draft) {
        this.ck_editor.setData(this.model.get('draft'));
      }else{
        this.ck_editor.setData(this.model.get(this.options.id));
      }

      // Bind change event
      this.ck_editor.model.document.on('change:data', _.bind(function(){
        console.log('editor content', this.ck_editor.getData());

        // Save the draft immediately
        if(this.options.enable_draft){
          this.model.set('draft', this.ck_editor.getData());

          // Save to backend
          this.save_draft();
        }else{
          this.model.set(this.options.id, this.ck_editor.getData());
        }
      }, this));

      if(this.options.enable_draft) {
        this.stickit();
      }else{
        this.$('.unsaved-changes').hide();
      }
    }, this))
    .catch(function(error){
      console.error( error );
    });
  },

  onDestroy: function(){
    if(!_.isNull(this.ck_editor)){
      this.ck_editor.destroy();
    }
  }
});